// fetchSearchData.ts
import { buildStrapiUrl } from '../utils/strapi-url';
import { fetchWithRetry } from './fetch-with-retry';

export async function fetchSearchData(query: string, locale: string) {
  const queryParams = new URLSearchParams();

  queryParams.append('locale', locale);

  const url = buildStrapiUrl('/api/web/search-data', queryParams);

  const response = await fetchWithRetry(url, { cache: 'force-cache' });
  if (!response.ok) return [];
  const data = await response.json();
  return Array.isArray(data) ? data.filter((item) => item?.publishedAt) : [];
}
